import Text from './_text.js'
import EventTimingStatus from './_event-timing-status.js'
import MiniScoreboard from './_mini-scoreboard.js'

export default {
  name: 'LegInfoRow',
  values: {
    showLiveScores: true,
    scoreboard: {
      sports: {
        setBased: [
          'tennis',
        ],
        periodBased: [
          'basketball',
          'ice_hockey',
          'soccer',
        ],
      },
    },
    separator: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 4px',
          flexGrow: 0,
        },
      },
    },
    textSeparator: '|',
    rowText: {
      configSet: Text,
      configValues: {
        style: {
          lineHeight: '16px',
        },
      },
    },
    eventTimingStatus: {
      configSet: EventTimingStatus,
      configValues: {
        showStreamIcon: false,
        container: {
          style: {
            base: {
              flexGrow: 0,
            },
          },
        },
      },
    },
    miniScoreboard: {
      configSet: MiniScoreboard,
      configValues: {
        rowDirection: true,
        redCard: {
          style: {
            bannerContainer: {
              left: 0,
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
